var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("span", { staticClass: "color-order-basket-title mb-3" }, [
          _vm._v(_vm._s(_vm.trans("sample_order_in_your_basket")) + ":"),
        ]),
        _c("color-sample-overview", {
          attrs: {
            canModifyQuantity: false,
            canModifyStructure: false,
            items: _vm.items,
            currency: _vm.currency,
          },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col col-12 col-md-6" }, [
        _c("div", { staticClass: "color-sample-details-title mb-4" }, [
          _vm._v(" " + _vm._s(_vm.trans("sample_order_billing_details")) + " "),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_name")) +
              ": " +
              _vm._s(_vm.customerData.billing_name) +
              " "
          ),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_company_name")) +
              ": " +
              _vm._s(_vm.customerData.billing_company_name) +
              " "
          ),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_address")) +
              ": " +
              _vm._s(_vm.customerData.billing_zip) +
              " " +
              _vm._s(_vm.customerData.billing_city) +
              ", " +
              _vm._s(_vm.customerData.billing_address) +
              " "
          ),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_vat_number")) +
              ": " +
              _vm._s(_vm.customerData.billing_vat_number) +
              " "
          ),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_email")) +
              ": " +
              _vm._s(_vm.customerData.billing_email) +
              " "
          ),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_phone")) +
              ": " +
              _vm._s(_vm.customerData.billing_phone) +
              " "
          ),
        ]),
      ]),
      _c("div", { staticClass: "col col-12 col-md-6" }, [
        _c("div", { staticClass: "color-sample-details-title mb-4" }, [
          _vm._v(
            " " + _vm._s(_vm.trans("sample_order_delivery_details")) + " "
          ),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_name")) +
              ": " +
              _vm._s(_vm.customerData.name) +
              " "
          ),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_company_name")) +
              ": " +
              _vm._s(_vm.customerData.company_name) +
              " "
          ),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_address")) +
              ": " +
              _vm._s(_vm.customerData.zip) +
              " " +
              _vm._s(_vm.customerData.city) +
              ", " +
              _vm._s(_vm.customerData.address) +
              " "
          ),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_email")) +
              ": " +
              _vm._s(_vm.customerData.email) +
              " "
          ),
        ]),
        _c("div", { staticClass: "color-sample-detail" }, [
          _vm._v(
            " " +
              _vm._s(_vm.trans("sample_order_phone")) +
              ": " +
              _vm._s(_vm.customerData.phone) +
              " "
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "row  mt-5" }, [
      false
        ? _c(
            "div",
            { staticClass: "color-order-back", on: { click: _vm.goBack } },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.trans(
                      "sample_order_back_to_delivery_and_billing_details"
                    )
                  ) +
                  " "
              ),
            ]
          )
        : _c("div", { staticClass: "col-12 col-md-6" }, [
            _c(
              "button",
              {
                staticClass: "button type-15 sample-order-checkout-back-button",
                attrs: { type: "button" },
                on: { click: _vm.goBack },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("keyboard_backspace"),
                ]),
                _vm._v(" " + _vm._s(_vm.trans("calc_navigation_back")) + " "),
              ]
            ),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }